import { cellRendererDisplay } from '../utils/formatter'

export default {

  computed: {
    display() {
      return cellRendererDisplay({
        type: this.params.colDef.cellRenderer,
        colDef: this.params.colDef,
        data: this.params.data,
        queriesData: this.params.colDef.cellRendererParams.preQuery,
        global: this.params.colDef.cellRendererParams.global,
        rowNumber: this.params.rowIndex + 1
      })
    }
  }

}
